import { render } from "./ClaudiuNicolaievPage.vue?vue&type=template&id=51df7fed"
import script from "./ClaudiuNicolaievPage.vue?vue&type=script&lang=js"
export * from "./ClaudiuNicolaievPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__